import { CALL_API } from '../../../middleware/api';
import { getProductId } from '../../../shared/domainUtils';
import * as ActionTypes from '../SignIn';
import { fetchFreebet } from '../../../sagas/api';
function fetchSignIn(data) {
    var _a;
    data['Product'] = getProductId();
    return _a = {
            type: ActionTypes.SIGNIN
        },
        _a[CALL_API] = {
            endpoint: '/auth/sign/in',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_SIGNIN,
                ActionTypes.FAILURE_SIGNIN
            ],
            credentials: true,
            data: data
        },
        _a;
}
export function getFreebet() {
    return function (dispatch) {
        dispatch({ type: ActionTypes.FETCH_FREEBET });
        return fetchFreebet().then(function (data) {
            if (Array.isArray(data)) {
                dispatch({ type: ActionTypes.SUCCESS_FETCH_FREEBET, data: data });
            }
            else {
                dispatch({ type: ActionTypes.FAILURE_FETCH_FREEBET, data: data });
            }
        });
    };
}
export function signIn(data) {
    return function (dispatch) {
        dispatch(fetchSignIn(data));
    };
}
export function rememberMe() {
    return { type: ActionTypes.REMEMBER_ME };
}
export function activateModalClose() {
    return { type: ActionTypes.DELETE_FETCH_ACTIVATE_EMAIL };
}
function fetchActivateEmail(data) {
    var _a;
    return _a = {
            type: ActionTypes.FETCH_ACTIVATE_EMAIL
        },
        _a[CALL_API] = {
            endpoint: '/recovery/init',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_FETCH_ACTIVATE_EMAIL,
                ActionTypes.FAILURE_FETCH_ACTIVATE_EMAIL
            ],
            data: data
        },
        _a;
}
export function activateEmail(data) {
    return function (dispatch) {
        dispatch(fetchActivateEmail(data));
    };
}
function fetchRestoreEmail(data) {
    var _a;
    return _a = {
            type: ActionTypes.FETCH_ACTIVATE_EMAIL
        },
        _a[CALL_API] = {
            endpoint: '/join/resend',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_FETCH_ACTIVATE_EMAIL,
                ActionTypes.FAILURE_FETCH_ACTIVATE_EMAIL
            ],
            data: data
        },
        _a;
}
export function restoreEmail(data) {
    return function (dispatch) {
        dispatch(fetchRestoreEmail(data));
    };
}



// WEBPACK FOOTER //
// ./src/actions/auth/creators/SignIn.js